let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bxUwt")).then(() => parcelRequire('cNjMs'));